<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
             <a-form-item :label="$t('label.farms')">
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectFarms')" v-model="queryParam.farmCode" dictCode="sys_depart,depart_name,org_code,org_category='5' and del_flag='0'"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.contracts')" >
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectContract')" v-model="queryParam.conCode" dictCode="efs_md_contract,name,code, del_flag='N'"/>
<!--              <j-input placeholder="请输入合同" v-model="queryParam.conCode"></j-input>-->
            </a-form-item>
          </a-col>
            <!--<a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="养户">
                <j-dict-select-tag :placeholder="$t('label.pleaseSelectGrower')"  v-model="queryParam.farmerCode" dictCode="efs_md_farmer,name,code, del_flag='N'"/>
               &lt;!&ndash; <j-input placeholder="请输入养户" v-model="queryParam.peasant"></j-input>&ndash;&gt;
              </a-form-item>
            </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.batch')">
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectBatch')" v-model="queryParam.batchCode" dictCode="efs_md_breed_batch,name,code"/>
              <!-- <j-input placeholder="请输入养户" v-model="queryParam.peasant"></j-input>-->
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
             <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <!--<div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('efs_margin_ledger')">{{$t('button.export')}}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>-->

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">


        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
        <!--<span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>-->

      </a-table>
    </div>

    <efs-margin-ledger-modal ref="modalForm" @ok="modalFormOk"></efs-margin-ledger-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMarginLedgerModal from './modules/EfsMarginLedgerModal'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'EfsMarginLedgerList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsMarginLedgerModal,
        JInput
    },
    data () {
      return {
        description: 'efs_margin_ledger管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
              slotName: 'tableHeader.farms',
              align:"center",
              dataIndex: 'farmCode_dictText',
            scopedSlots: { title: 'tableHeader.farms'}
          },
          {
            slotName: 'tableHeader.contracts',
            scopedSlots: { title: 'tableHeader.contracts'},
            align:"center",
            dataIndex: 'conCode_dictText'
          },
            {
                slotName: 'tableHeader.batch',
            scopedSlots: { title: 'tableHeader.batch'},
                align:"center",
                dataIndex: 'batchCode_dictText'
            },
          {
            slotName: 'tableHeader.grower',
            scopedSlots: { title: 'tableHeader.grower'},
            align:"center",
            dataIndex: 'farmerCode_dictText'
          },
          /*{
            slotName: 'tableHeader.batchSize',
            scopedSlots: { title: 'tableHeader.batchSize'},
            align:"center",
            dataIndex: 'planBreedQty'
          },*/
          /*{
            slotName: 'tableHeader.grower',
            scopedSlots: { title: 'tableHeader.grower'},
            align:"center",
            dataIndex: 'peasant'
          },*/

          {
            slotName: 'tableHeader.businessDate',
            scopedSlots: { title: 'tableHeader.businessDate'},
            align:"center",
            dataIndex: 'businessDate',
            customRender:function (text) {
                return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            slotName: 'tableHeader.amount',
            scopedSlots: { title: 'tableHeader.amount'},
            align:"center",
            dataIndex: 'amountPrice'
          },
          {
            slotName: 'tableHeader.businessType',
            scopedSlots: { title: 'tableHeader.businessType'},
            align:"center",
            dataIndex: 'businessType'
          },
            {
                slotName: 'tableHeader.operationTime',
            scopedSlots: { title: 'tableHeader.operationTime'},
                align:"center",
                dataIndex: 'operationTime'
            },
        ],
        url: {
          list: "/demo/marginLedger/efsMarginLedger/list",
          delete: "/demo/marginLedger/efsMarginLedger/delete",
          deleteBatch: "/demo/marginLedger/efsMarginLedger/deleteBatch",
          exportXlsUrl: "/demo/marginLedger/efsMarginLedger/exportXls",
          importExcelUrl: "demo/marginLedger/efsMarginLedger/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>